import styled, { css } from 'styled-components';
import {
  SLIDER_LABEL_WIDTH,
  SLIDER_READOUT_WIDTH,
  SLIDER_THUMB_SIZE,
  SLIDER_TRACK_HEIGHT,
} from './Slider.constants';

export const Root = styled.div`
  display: grid;
  grid-template-columns: ${SLIDER_LABEL_WIDTH} minmax(0, 1fr) ${SLIDER_READOUT_WIDTH};
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: ${({ theme: { colors = {} } }) => colors.onSurface ?? '#E4E1ED'};
`;

export const Readout = styled.span`
  text-align: right;
  font-variant-numeric: tabular-nums;
  color: ${({ theme: { colors = {} } }) => colors.onSurfaceVariant ?? '#C7C4D7'};
`;

const thumb = css`
  width: ${SLIDER_THUMB_SIZE};
  height: ${SLIDER_THUMB_SIZE};
  border: 0;
  border-radius: 50%;
  background: ${({ theme: { colors = {} } }) => colors.primary ?? '#C1C1FF'};
  transition: box-shadow 120ms ease;
`;

export const Input = styled.input<{ $fill: number }>`
  appearance: none;
  width: 100%;
  height: ${SLIDER_TRACK_HEIGHT};
  margin: 0;
  border-radius: 999px;
  background: ${({ $fill, theme: { colors = {} } }) => {
    const accent = colors.primary ?? '#C1C1FF';
    const track = colors.surfaceContainerHighest ?? '#34343D';
    return `linear-gradient(to right, ${accent} ${$fill}%, ${track} ${$fill}%)`;
  }};
  cursor: pointer;

  &::-webkit-slider-thumb {
    appearance: none;
    ${thumb}
  }
  &::-moz-range-thumb {
    ${thumb}
  }
  &:hover:not(:disabled)::-webkit-slider-thumb,
  &:focus-visible::-webkit-slider-thumb {
    box-shadow: 0 0 0 6px
      ${({ theme: { colors = {} } }) =>
        `color-mix(in srgb, ${colors.primary ?? '#C1C1FF'} 24%, transparent)`};
  }
  &:hover:not(:disabled)::-moz-range-thumb,
  &:focus-visible::-moz-range-thumb {
    box-shadow: 0 0 0 6px
      ${({ theme: { colors = {} } }) =>
        `color-mix(in srgb, ${colors.primary ?? '#C1C1FF'} 24%, transparent)`};
  }
  &:focus-visible {
    outline: none;
  }
  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;
